module.exports = __webpack_public_path__ + "static/img/logo_ccov.192c733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ccov.png
// module id = ANs3
// module chunks = 1